export default __webpack_public_path__ + "Mask-group-20.ed42b7.svg";